export default "__VITE_ASSET__BgtBZsNF__"